<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" name="name" type="text" class="form-control" [(ngModel)]="target.name" required />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="sortOrder">Sort Order</label>
                    <input id="sortOrder" name="sortOrder" type="number" class="form-control" [(ngModel)]="target.sortOrder" required />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="colorHex">Color</label>
                    <input id="colorHex" name="colorHex" type="text" class="form-control" [(ngModel)]="target.colorHex" required maxlength="9" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="leadTimeDays">Lead Time (days)</label>
                    <input id="leadTimeDays" name="leadTimeDays" type="number" class="form-control" [(ngModel)]="target.leadTimeDays" required />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="progressWeight">Progress Weight</label>
                    <input
                        id="progressWeight"
                        name="progressWeight"
                        type="number"
                        step="0.0001"
                        class="form-control"
                        [(ngModel)]="target.progressWeight"
                        required
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="category">Category</label>
                    <select id="category" name="category" class="form-select" [(ngModel)]="target.category" required>
                        @for (opt of categoryOptions; track opt.value) {
                            <option [ngValue]="opt.value">{{ opt.display }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group form-check mt-4">
                    <input id="active" name="active" type="checkbox" class="form-check-input" [(ngModel)]="target.active" />
                    <label class="form-check-label" for="active">Active (shown on board)</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
